import { axiosService } from '../.';

export default class RequestOrganizationBusinessChangeOfPricing {
    public async execute(input: RequestOrganizationBusinessChangeOfPricingDto): Promise<void> {
        await axiosService.instance.post(`businesses/organization/request-to-change-pricing`, { ...input });
    }
}

export class RequestOrganizationBusinessChangeOfPricingDto {
    private businessId: number;
    private pricingId: number;

    constructor(businessId: number, pricingId: number) {
        this.businessId = businessId;
        this.pricingId = pricingId;
    }
}

export const requestOrganizationBusinessChangeOfPricing = new RequestOrganizationBusinessChangeOfPricing();
